import apiClient from './client'

export interface PlayerDetail {
  id: number
  first_name: string
  last_name: string
  full_name: string
  bats: string
  throws: string
  birth_date: string | null
  debut_date: string | null
  last_game_date: string | null
  retrosheet_id: string | null
  mlbam_id: number | null
  height_inches: number | null
  weight: number | null
  birth_city: string | null
  birth_state: string | null
  birth_country: string | null
  nickname: string | null
}

export const referenceApi = {
  async getPlayer(playerId: number): Promise<PlayerDetail> {
    const response = await apiClient.get<PlayerDetail>(`/players/${playerId}`)
    return response.data
  }
}

export default referenceApi
